export const saveScrollPosition = (options) => {
    const { currentView, setDashboardScrollPosition } = options;
    if (currentView === "dashboard") {
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        setDashboardScrollPosition(scrollY);
    }
};
export const restoreScrollPosition = (options) => {
    const { dashboardScrollPosition, setContentVisible } = options;
    if (dashboardScrollPosition <= 0) {
        setContentVisible(true);
        return;
    }
    setContentVisible(false);
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            const maxScroll = Math.max(document.body.scrollHeight - window.innerHeight, document.documentElement.scrollHeight - window.innerHeight, 0);
            const targetScroll = Math.min(dashboardScrollPosition, maxScroll);
            if (targetScroll > 0) {
                window.scrollTo({
                    top: targetScroll,
                    behavior: "instant",
                });
            }
            setTimeout(() => {
                setContentVisible(true);
            }, 50);
        });
    });
};
//# sourceMappingURL=scrollManagementUtils.js.map